import React, { useState, useRef, forwardRef, useImperativeHandle, useCallback, } from 'react';
import { ScrollView, Animated, View, Easing, } from 'react-native';
import TabItem from './TabItem';
import Slider from './Slider';
import { useStyle } from '../styles';
import throttle from 'lodash.throttle';
const TabBar = forwardRef((props, ref) => {
    const { kidtoken = '', scalable = false, customStyle = {}, type, sliderAnimate, showSlider, renderLeftSection, renderRightSection, routes, defaultIndex, activeIndex, onTabBarItemPress, tabBarMode, } = props;
    const { style } = useStyle({
        kidtoken,
        scalable,
        customStyle,
    });
    const [selectedIndex, setSelectedIndex] = useState(undefined);
    const sliderLeftValue = useRef(new Animated.Value(0)).current;
    const scrollView = useRef(null);
    const [scrollViewWidth, setScrollViewWidth] = useState(0);
    const tabItemLayout = useRef({}).current;
    const [sliderMoved, setSliderMoved] = useState(false);
    const activeIndexRef = useRef(activeIndex);
    activeIndexRef.current = activeIndex;
    // 是否有item被选中
    const handleTabPress = useCallback(throttle((params) => {
        var _a;
        const { id, index } = params;
        onTabBarItemPress && onTabBarItemPress({ id, index });
        activeIndex === undefined && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex(index));
    }, 500), [onTabBarItemPress]);
    const scrollToIndex = (index) => {
        if (index !== selectedIndex && selectedIndex !== undefined) {
        }
        if (!tabItemLayout[index]) {
            return;
        }
        const { x, width } = tabItemLayout[index];
        let leftValue = x; //当前tabItem的距离左侧的距离
        let widthValue = width; //当前tabItem的宽度
        if (sliderAnimate) {
            Animated.timing(sliderLeftValue, {
                toValue: leftValue + widthValue / 2,
                duration: 150,
                easing: Easing.linear,
                useNativeDriver: false,
            }).start(() => {
                setSliderMoved(true);
            });
        }
        else {
            sliderLeftValue.setValue(leftValue + widthValue / 2);
            setSliderMoved(true);
        }
        const lastTabItemLayout = tabItemLayout[props.routes.length - 1];
        if (scrollView.current && lastTabItemLayout && scrollViewWidth) {
            const pageCenterX = (scrollViewWidth - width) / 2; //将当前tabItem的中心置于tabBar之后，该tabItem的left值
            const firstX = 0 + pageCenterX;
            const lastX = lastTabItemLayout.x - pageCenterX;
            if (x < firstX || index === 0) {
                scrollView.current.scrollTo({
                    x: 0,
                    y: 0,
                    animated: true,
                });
            }
            else if (x > lastX) {
                scrollView.current.scrollToEnd({ animated: true });
            }
            else {
                const dx = x - pageCenterX;
                scrollView.current.scrollTo({
                    x: dx,
                    y: 0,
                    animated: true,
                });
            }
            setSelectedIndex(index);
        }
    };
    // 使用useImperativeHandle包裹scrollToIndex，供父组件使用
    useImperativeHandle(ref, () => ({
        scrollToIndex,
    }));
    return (React.createElement(View, { testID: "tabBarContainer", style: style.tabBar },
        renderLeftSection && renderLeftSection(),
        React.createElement(ScrollView, { testID: "tabBarScrollView", style: [{ flex: 1, height: '100%' }], ref: scrollView, contentContainerStyle: [
                style.tabBarContentContainerStyle,
                tabBarMode === 'fixed' && { width: '100%' },
            ], horizontal: true, showsHorizontalScrollIndicator: false, scrollEnabled: true, bounces: tabBarMode === 'fixed' ? false : true, onLayout: ({ nativeEvent: { layout } }) => {
                setScrollViewWidth(layout.width);
            } },
            routes.map((route, index) => {
                var _a;
                // 判断当前tabItem是否被选中
                const isActive = index ===
                    ((_a = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : activeIndex) !== null && _a !== void 0 ? _a : defaultIndex);
                return (React.createElement(TabItem, { route: route, type: type, tabBarMode: tabBarMode, key: route.id, onTabLayout: ({ nativeEvent: { layout } }) => {
                        var _a;
                        // 初始化时slider滚动到默认位置
                        tabItemLayout[index] = layout;
                        if (((index === defaultIndex ||
                            index === activeIndexRef.current) &&
                            selectedIndex === undefined) ||
                            activeIndexRef.current === index) {
                            scrollToIndex((_a = activeIndexRef.current) !== null && _a !== void 0 ? _a : defaultIndex);
                        }
                    }, isActive: isActive, onPress: () => {
                        handleTabPress({ id: route.id, index });
                    }, customStyle: customStyle }));
            }),
            showSlider && sliderMoved && (React.createElement(Slider, { leftValue: sliderLeftValue, type: type, customStyle: customStyle }))),
        renderRightSection && renderRightSection()));
});
export default TabBar;
